export const ru = {
    active: 'Идет сбор данных.',
    'active-text':
        'Достпуны промежуточные результаты, они могут отличаться от финальных результатов',
    brandlift: 'Исследование Brand Lift',
    cancel: 'Отмена',
    close: 'Закрыть',
    completed: 'Опрос завершен',
    draft: 'Черновик.',
    'draft-text':
        'Сбор данных начнется после того, как исследование продет модерацию',
    moderation: 'Отправлено на модерацию',
    'moderation-text':
        'Сбор данных начнется после того, как исследование продет модерацию',
    params: 'Параматры исследования',
    reject: 'Исследование отклонено модерацией.',
    result: 'Результаты исследования',
    save: 'Сохранить',
    stop: 'Опрос остановлен.',
    'stop-active': 'Исследование Brand Lift остановлено:',
    'stop-active-budget': 'бюджет кампании меньше 500 000 рублей.',
    'stop-active-budget-and-coverage':
        'бюджет кампании меньше 500 000 рублей и охват кампании меньше 2 млн.',
    'stop-active-coverage': 'охват кампании меньше 2 млн.',
    'stop-budget':
        'Бюджета кампании недостаточно для проведения Brand Lift. Увеличьте бюджет до 500 000 рублей.',
    'stop-budget-and-coverage':
        'Бюджета и охвата кампании недостаточно для проведения Brand Lift. Измените условия нацеливания, чтобы прогнозируемый охват был не менее 2 млн, и увеличьте бюджет до 500 000 рублей.',
    'stop-coverage':
        'Охвата кампании недостаточно для проведения Brand Lift. Измените условия нацеливания, чтобы прогнозируемый охват был не менее 2 млн.'
};
